import { getRequest } from "../request";
import { CREATE_BASVURU_WITH_ALTSUREC_LIST } from "../constants/requestUrls";

const createBasvuruWithAltSurecList = (basvuruId) => {
    return getRequest({url:CREATE_BASVURU_WITH_ALTSUREC_LIST + '?basvuruId=' + basvuruId});
}


export default createBasvuruWithAltSurecList;